var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafePalWalletLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0513 4C21.7287 4 20.4603 4.52541 19.525 5.46064L4.83461 20.1513C4.2782 20.7078 4 21.4371 4 22.1664C4.00001 22.8957 4.27822 23.6249 4.83463 24.1813L14.4618 33.8084V16.7649C14.4618 15.493 15.4848 14.4619 16.7567 14.4619C22.1303 14.4619 35.2106 14.4619 36.9948 14.4619L47.4564 4.00015L23.0513 4Z",
    fill: "#4B21EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4617 36.9951H34.6917C35.9636 36.9951 36.9948 35.964 36.9948 34.6921V17.6486L46.6218 27.2758C47.1782 27.8321 47.4564 28.5614 47.4564 29.2907C47.4564 30.02 47.1782 30.7493 46.6218 31.3057L31.9313 45.9964C30.9962 46.9317 29.7277 47.4571 28.4051 47.4571L4 47.4568L14.4617 36.9951Z",
    fill: "#4B21EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafePalWalletLogo);
export default __webpack_public_path__ + "static/media/safePalWalletLogo.a334160a.svg";
export { ForwardRef as ReactComponent };